import { connect } from 'react-redux'
import { selectLanguage } from 'store/locales'
import ArticleFive from '../components/ArticleFive'

const mapStateToProps = ({ strings }) => {
  return {
    strings,
  }
}

const mapDispatchToProps = {
  selectLanguage,
}

export default connect(mapStateToProps, mapDispatchToProps)(ArticleFive)
